import { render, staticRenderFns } from "./MeditationBlock.vue?vue&type=template&id=577a63eb&"
import script from "./MeditationBlock.vue?vue&type=script&lang=js&"
export * from "./MeditationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports